import React from "react";

class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      message: "",
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      message: error?.message || "Terjadi error pada halaman ini.",
    };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error("PageErrorBoundary:", error, info);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleBack = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = "/";
    }
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div className="container-fluid py-4">
        <div className="alert alert-danger shadow-sm">
          <h5 className="mb-2">Halaman ini mengalami kendala.</h5>
          <div className="mb-3">
            Halaman lain tetap bisa digunakan. Silakan muat ulang halaman ini.
          </div>

          {this.state.message ? (
            <pre
              className="bg-light border rounded p-2 mb-3"
              style={{ whiteSpace: "pre-wrap", fontSize: 12 }}
            >
              {this.state.message}
            </pre>
          ) : null}

          <button className="btn btn-danger btn-sm mr-2" onClick={this.handleReload}>
            Reload Halaman
          </button>
          <button className="btn btn-outline-secondary btn-sm" onClick={this.handleBack}>
            Kembali
          </button>
        </div>
      </div>
    );
  }
}

export default PageErrorBoundary;
